import React, { useMemo, useState } from "react";
import Styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";

import usdtIcon from "../../../theme/assets/svg/tc_crypto_usdt_icon.svg";
import tcIcon from "../../../theme/assets/svg/tc_crypto_tc_m_icon.svg";
import { useDispatch } from "react-redux";
import { getBuyTokenData } from "../../../store/cabinet/action";
// import {getBuyTokenData, setPreSaleBuyModalStatus} from "../../../store/cabinet/action";


const IS_PURCHASE_DISABLED = true;

const CabinetPreSaleBuy = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const rate = 0.5;

    const [usdtValue, setUsdtValue] = useState("");
    const [tcValue, setTcValue] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const normalizeIntegerInput = (value) => {
        let normalized = value.replace(/[^\d]/g, "");

        // Убираем лишние нули в начале, но оставляем один 0.
        normalized = normalized.replace(/^0+(?=\d)/, "");

        return normalized;
    };

    const formatIntegerValue = (value) => {
        if (!Number.isFinite(value) || value <= 0) return "";

        return Math.floor(value).toString();
    };

    const handleUsdtChange = (event) => {
        const value = normalizeIntegerInput(event.target.value);

        setUsdtValue(value);

        const numericValue = Number(value);

        if (!value || numericValue <= 0) {
            setTcValue("");
            return;
        }

        const calculatedTc = Math.floor(numericValue * rate);

        setTcValue(calculatedTc >= 1 ? calculatedTc.toString() : "");
    };

    const handleTcChange = (event) => {
        const value = normalizeIntegerInput(event.target.value);

        setTcValue(value);

        const numericValue = Number(value);

        if (!value || numericValue <= 0) {
            setUsdtValue("");
            return;
        }

        setUsdtValue(formatIntegerValue(numericValue / rate));
    };

    const isBtnActive = useMemo(() => {
        const usdtNumber = Number(usdtValue);
        const tcNumber = Number(tcValue);

        return (
            !IS_PURCHASE_DISABLED &&
            !isLoading &&
            usdtValue !== "" &&
            tcValue !== "" &&
            Number.isFinite(usdtNumber) &&
            Number.isFinite(tcNumber) &&
            Number.isInteger(usdtNumber) &&
            Number.isInteger(tcNumber) &&
            usdtNumber > 0 &&
            tcNumber >= 1
        );
    }, [usdtValue, tcValue, isLoading]);

    const buyTokensHandler = async () => {
        if (!isBtnActive) return;

        try {
            setIsLoading(true);

            dispatch(getBuyTokenData({
                token_sale_id: 1,
                qty: Number(tcValue),
            }));

            setUsdtValue("");
            setTcValue("");
        } catch (error) {
            console.error("Buy tokens error:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.cabinetPC} ${Styles.perspective3dXl}`}>
                <div className={`${Styles.cardWrap} ${Styles.border3dOuterXl} ${Styles.rotate3dRightXl}`}>
                    <div className={`${Styles.cardBox}`}>
                        <div className={`${Styles.contentWrapTitle}`}>
                            {t("Купить токены $TC")}
                        </div>

                        <div className={`${Styles.contentBox}`}>
                            <div className={`${Styles.inputWrap}`}>
                                <div className={`${Styles.inputTitle}`}>
                                    {t("Вы отдаете")}
                                </div>

                                <div className={`${Styles.inputBox}`}>
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        value={usdtValue}
                                        onChange={handleUsdtChange}
                                        placeholder="0"
                                    />

                                    <div className={`${Styles.inputBoxCurrency}`}>
                                        <div className={`${Styles.inputBoxCurrencyIcon}`}>
                                            <img src={usdtIcon} alt="USDT" />
                                        </div>

                                        <div className={`${Styles.inputBoxCurrencyText}`}>
                                            USDT
                                        </div>
                                    </div>
                                </div>

                                <div className={`${Styles.inputNote}`}>
                                    {t("Введите сумму на которую хотите купить токены")}
                                </div>
                            </div>

                            <div className={`${Styles.inputWrap}`}>
                                <div className={`${Styles.inputTitle}`}>
                                    {t("Вы получаете")}
                                </div>

                                <div className={`${Styles.inputBox}`}>
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        value={tcValue}
                                        onChange={handleTcChange}
                                        className={`${Styles.inputTC}`}
                                        placeholder="0"
                                    />

                                    <div className={`${Styles.inputBoxCurrency}`}>
                                        <div className={`${Styles.inputBoxCurrencyIcon}`}>
                                            <img src={tcIcon} alt="$TC" />
                                        </div>

                                        <div className={`${Styles.inputBoxCurrencyText}`}>
                                            $TC
                                        </div>
                                    </div>
                                </div>

                                <div className={`${Styles.inputNote}`}>
                                    {t("Кол-во токенов, которые вы получите")}
                                </div>
                            </div>

                            <button
                                type="button"
                                className={`${Styles.mainBtn} ${isBtnActive ? Styles.mainBtnActive : ""}`}
                                onClick={buyTokensHandler}
                                disabled={!isBtnActive}
                            >
                                {isLoading ? t("Загрузка...") : t("Купить")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CabinetPreSaleBuy;